const styles = theme => ({
  coverImage: {
    minHeight: '160px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer',
    position: 'relative',
    borderRadius: '12px',
  },

  courseGalleryView: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    overflow: 'hidden',
    height: '320px',
    transition: 'all 0.3s ease-in-out',
    padding: '8px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    backgroundColor: '#FFFFFF',
  },
  courseSortView: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    height: 130,
    width: 130,
    cursor: 'grab',
    borderRadius: 16,
    margin: 8,
  },
  buttons: {
    display: 'flex',
    backgroundColor: '#ffffff',
    height: '42px',
    color: '#002E47',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#015FFB',
    },
  },
  learnersAccessButton: {
    display: 'flex',
    backgroundColor: '#015FFB',
    height: '42px',
    maxWidth: '140px',
    width: '100%',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#015FFB',
      color: '#fff',
    },
  },
  buttonEdit: {
    display: 'flex',
    backgroundColor: '#ffffff',
    height: '42px',
    maxWidth: '140px',
    width: '100%',
    color: '#002E47',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#015FFB',
    },
  },
  buttonCollection: {
    display: 'flex',
    backgroundColor: '#ffffff',
    height: '42px',
    maxWidth: '150px',
    width: '100%',
    color: '#002E47',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#015FFB',
    },
  },
  iconButton: {
    width: '42px',
    height: '42px',
    borderRadius: '1rem',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#015FFB',
    },
  },
  buttonText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  kanbanColumnAdd__paper: {
    width: '100%',
    backgroundColor: '#f4f6f8',
    borderRadius: '16px',
    height: '40px',
  },
  kanbanColumnAdd__button: {
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'row',
    height: '40px',
    justifyContent: 'center',
    border: 'none',
  },
  kanbanColumnAdd__text: {
    color: '#1D1D1F',
    fontSize: '14px',
    fontWeight: 500,
  },
  flexGrowContainer: {
    flexGrow: 1,
  },
  moveIcon: {
    padding: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    margin: '16px',
    borderRadius: '50%',
  },
  courseNameBox: {
    cursor: 'pointer',
    padding: 1,
    paddingRight: 2,
    paddingLeft: 2,
    flexGrow: 1,
  },
  courseNameTypography: {
    whiteSpace: 'normal',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transition: 'opacity 200ms ease-in-out',
    fontWeight: 500,
  },
  toolbarContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  hoverContainer: {
    display: 'flex',
  },
  miniCourseIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#919EAB',
  },
  miniCourseText: {
    color: '#919EAB',
    fontSize: '12px',
    fontWeight: 500,
  },
  courseContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px 8px',
    height: '100%',
  },
})

export default styles
